export const newCampaignTemplateES = {
    audience: "100",
    date_ends: null,
    date_starts: null,
    design: {
        generalBackgroundType: "none",
        generalBackgroundURL: {},
        generalColorsBackground: "#ffffff",
        generalColorsText: "#1C1D2E",
        generalColorsTitle: "#00CDEE",
        generalLogoText: "Alyze",
        generalLogoType: "image",
        generalLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        generalPrimaryBtnBackground: "#00CDEE",
        generalPrimaryBtnBorderRadius: "2",
        generalPrimaryBtnText: "#ffffff",
        generalPrimaryBtnType: "solid",
        generalSecondaryBtnBackground: "#1C1D2E",
        generalSecondaryBtnBorderRadius: "0",
        generalSecondaryBtnText: "#ffffff",
        generalSecondaryBtnType: "text",
        landingBackgroundType: "none",
        landingBackgroundURL: {},
        landingColorsBackground: "#1C1D2E",
        landingColorsText: "#ffffff",
        landingColorsTitle: "#ffffff",
        landingLogoText: "Alyze",
        landingLogoType: "image",
        landingLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        landingPrimaryBtnBackground: "#ffffff",
        landingPrimaryBtnBorderRadius: "2",
        landingPrimaryBtnText: "#00CDEE",
        landingPrimaryBtnType: "solid",
        landingSecondaryBtnBackground: "#1C1D2E",
        landingSecondaryBtnBorderRadius: "0",
        landingSecondaryBtnText: "#ffffff",
        landingSecondaryBtnType: "text"
    },
    modules: {
        coreModulesPre: [
            {
                id: "core-landing",
                type: "landing",
                name: "Landing",
                img: "card-text.png",
                title: "¡Hola!",
                text: "Queremos conocer tu opinión respecto a varios contenidos de nuestra empresa",
                button: "Siguiente",
                options: true
            },
            {
                id: "core-introduction",
                type: "text",
                name: "Introduction",
                img: "card-text.png",
                title: "",
                text: "Por ello te mostraremos unos contenidos en este análisis\n\nPara poder escuchar correctamente debes conectar\ntus auriculares",
                button: "Empezar",
                options: true
            },
            {
                id: "core-login",
                type: "login",
                name: "Login",
                img: "card-login.png",
                options: false
            }
        ],
        coreModulesPost: [
            {
                id: "core-finish",
                type: "text",
                name: "Finish",
                img: "card-text.png",
                title: "¡Gracias por participar!",
                text: "Tu opinión nos ayuda a ser mejores",
                button: "Finalizar",
                options: true
            }
        ],
        campaignModules: [],
    },
    interactions: "0",
    name: "Nuevo Test",
    status: "draft",
    url: null,
    lang: "es"
}

export const newCampaignTemplateEN = {
    audience: "100",
    date_ends: null,
    date_starts: null,
    design: {
        generalBackgroundType: "none",
        generalBackgroundURL: {},
        generalColorsBackground: "#ffffff",
        generalColorsText: "#1C1D2E",
        generalColorsTitle: "#00CDEE",
        generalLogoText: "Alyze",
        generalLogoType: "image",
        generalLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        generalPrimaryBtnBackground: "#00CDEE",
        generalPrimaryBtnBorderRadius: "2",
        generalPrimaryBtnText: "#ffffff",
        generalPrimaryBtnType: "solid",
        generalSecondaryBtnBackground: "#1C1D2E",
        generalSecondaryBtnBorderRadius: "0",
        generalSecondaryBtnText: "#ffffff",
        generalSecondaryBtnType: "text",
        landingBackgroundType: "none",
        landingBackgroundURL: {},
        landingColorsBackground: "#1C1D2E",
        landingColorsText: "#ffffff",
        landingColorsTitle: "#ffffff",
        landingLogoText: "Alyze",
        landingLogoType: "image",
        landingLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        landingPrimaryBtnBackground: "#ffffff",
        landingPrimaryBtnBorderRadius: "2",
        landingPrimaryBtnText: "#00CDEE",
        landingPrimaryBtnType: "solid",
        landingSecondaryBtnBackground: "#1C1D2E",
        landingSecondaryBtnBorderRadius: "0",
        landingSecondaryBtnText: "#ffffff",
        landingSecondaryBtnType: "text"
    },
    modules: {
        coreModulesPre: [
            {
                id: "core-landing",
                type: "landing",
                name: "Landing",
                img: "card-text.png",
                title: "¡Hello!",
                text: "We would like to get your feedback on different contents regarding our company",
                button: "Next",
                options: true
            },
            {
                id: "core-introduction",
                type: "text",
                name: "Introduction",
                img: "card-text.png",
                title: "",
                text: "Therefore, we will show you some contents during this analysis\n\n You must connect your headphones \nto listen properly",
                button: "Begin",
                options: true
            },
            {
                id: "core-login",
                type: "login",
                name: "Login",
                img: "card-login.png",
                options: false
            }
        ],
        coreModulesPost: [
            {
                id: "core-finish",
                type: "text",
                name: "Finish",
                img: "card-text.png",
                title: "¡Thanks for participating!",
                text: "Your opinion will help us improve our service",
                button: "Close",
                options: true
            }
        ],
        campaignModules: [],
    },
    interactions: "0",
    name: "New Test",
    status: "draft",
    url: null,
    lang: "en"
}

export const newCampaignTemplateExpress = {
    audience: "100",
    date_ends: null,
    date_starts: null,
    design: {
        generalBackgroundType: "none",
        generalBackgroundURL: {},
        generalColorsBackground: "#ffffff",
        generalColorsText: "#1C1D2E",
        generalColorsTitle: "#00CDEE",
        generalLogoText: "Alyze",
        generalLogoType: "image",
        generalLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        generalPrimaryBtnBackground: "#00CDEE",
        generalPrimaryBtnBorderRadius: "2",
        generalPrimaryBtnText: "#ffffff",
        generalPrimaryBtnType: "solid",
        generalSecondaryBtnBackground: "#1C1D2E",
        generalSecondaryBtnBorderRadius: "0",
        generalSecondaryBtnText: "#ffffff",
        generalSecondaryBtnType: "text",
        landingBackgroundType: "none",
        landingBackgroundURL: {},
        landingColorsBackground: "#1C1D2E",
        landingColorsText: "#ffffff",
        landingColorsTitle: "#ffffff",
        landingLogoText: "Alyze",
        landingLogoType: "image",
        landingLogoURL: {
            "name":"templateLogo.png",
            "fileName":"templateLogo.png"
        },
        landingPrimaryBtnBackground: "#ffffff",
        landingPrimaryBtnBorderRadius: "2",
        landingPrimaryBtnText: "#00CDEE",
        landingPrimaryBtnType: "solid",
        landingSecondaryBtnBackground: "#1C1D2E",
        landingSecondaryBtnBorderRadius: "0",
        landingSecondaryBtnText: "#ffffff",
        landingSecondaryBtnType: "text"
    },
    modules: {
        coreModulesPre: [
            {
                id: "core-landing",
                type: "landing",
                name: "Landing",
                img: "card-text.png",
                title: "¡Hola!",
                text: "Quiero conocer tu opinión sobre estos contenidos que te voy a mostrar",
                button: "Siguiente",
                options: true
            },
            {
                id: "core-introduction",
                type: "text",
                name: "Introduction",
                img: "card-text.png",
                title: "",
                text: "Es un test de última tecnología con reconocimiento emocional\n\nTe recomiendo utilizar auriculares",
                button: "Empezar",
                options: true
            },
            {
                id: "core-login",
                type: "login",
                name: "Login",
                img: "card-login.png",
                options: false
            }
        ],
        coreModulesPost: [
            {
                id: "core-finish",
                type: "text",
                name: "Finish",
                img: "card-text.png",
                title: "¡Gracias por participar!",
                text: "Tu opinión es de gran ayuda",
                button: "Finalizar",
                options: true
            }
        ],
        campaignModules: [],
    },
    interactions: "0",
    name: "Nuevo Test",
    status: "draft",
    url: null,
    lang: "es"
}